import { AccordionState } from './definitions';

export class AccordionFactory 
{
	public static build(): AccordionState 
	{
		return {
			title: '',
			isCollapsed: false,
			accordion: true,
			icon: {
				iconPath: '',
				altText: ''
			}
		};
	}
}
